// WhatsApp is user-scoped, not team-scoped like Instagram — no fan-out, no elevated-role gate.

import { MessagingExecutionType, TriggerKey } from '@this+that/models';

export const WHATSAPP_TRIGGER_KEYS = [TriggerKey.WHATSAPP_NEW_MESSAGE];

export interface WhatsAppNewMessageTriggerConfig {
  /** WhatsAppMetaCredentials.phoneNumberId — the business number that receives. */
  phoneNumberId: string;
  executionType: MessagingExecutionType;
  /** Only applies when executionType === DEBOUNCE. Defaults to DEFAULT_DEBOUNCE_MINUTES. */
  debounceMinutes?: number;
}

// TEXT is only delivered inside the 24h customer-service window; outside it, only TEMPLATE.
export enum WhatsAppSendKind {
  TEXT = 'TEXT',
  TEMPLATE = 'TEMPLATE',
}

export interface SendWhatsAppMessageStepConfig {
  /** The business phone number ID that sends. Supports template variables. */
  phoneNumberId: string;
  /**
   * Recipient — a BSUID, or E.164 without '+'. Supports template variables.
   * Pass it through verbatim; the send path routes each form to its own Graph
   * API field.
   */
  to: string;
  kind: WhatsAppSendKind;
  /** Required when kind is TEXT. Supports template variables. */
  message?: string;
  /** Optional wamid to quote. Only applies when kind is TEXT. */
  replyToMessageId?: string;
  /** Required when kind is TEMPLATE. Approved name from WhatsApp Manager. */
  templateName?: string;
  /** Required when kind is TEMPLATE. BCP-47, e.g. 'pt_BR'. */
  templateLanguageCode?: string;
  /** Ordered body-parameter values for the template. Support template variables. */
  templateBodyParameters?: string[];
}
